export function toggleSettings(isActive) {
  return (dispatch) => {
    return dispatch({
      type: 'TOGGLE_SETTINGS',
      payload: {
        isActive: isActive
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/store/actions/settingsAction.js